import { localDateFromApi } from "../utils/dateTime";
import {
  VictoryChart,
  VictoryAxis,
  VictoryPortal,
  VictoryLabel,
  VictoryLine,
  VictoryScatter,
  VictoryTheme,
  VictoryTooltip,
} from "victory";
import React from "react";

class MonthProfitChart extends React.Component {
  prepareData(trades) {
    const monthData = trades.reduce((acc, trade) => {
      const dateEpochMillis =
        localDateFromApi(trade.date)
          .withDayOfMonth(1)
          .toEpochDay() *
        24 *
        3600 *
        1000;

      let list = acc.get(dateEpochMillis);
      if (!list) {
        list = [];
        acc.set(dateEpochMillis, list);
      }

      list.push(trade.profit);
      return acc;
    }, new Map());

    const profitMonthArray = [];

    // Remap to profit array
    monthData.forEach((list, dateEpochMillis) => {
      const profitMonth = list.reduce((acc, profit) => {
        return acc + profit;
      }, 0);

      profitMonthArray.push({ dateEpochMillis, profitMonth });
    });

    profitMonthArray.sort((a, b) => a.dateEpochMillis - b.dateEpochMillis);

    const result = [];

    let accumulatingProfit = this.props.tradeTotal;

    // Remap to profit % array
    profitMonthArray.forEach(item => {
      result.push({
        x: item.dateEpochMillis,
        y: MonthProfitChart.calculatePct(item.profitMonth, accumulatingProfit),
      });

      accumulatingProfit += item.profitMonth;
    });

    return result;
  }

  static calculatePct(value, max) {
    return value / max * 100;
  }

  render() {
    if (!this.props.trades) return null;

    const data = this.prepareData(this.props.trades);

    return (
      <VictoryChart
        scale={{ x: "time", y: "linear" }}
        width={this.props.width}
        domainPadding={20}
        theme={VictoryTheme.material}
      >
        <VictoryAxis
          dependentAxis
          style={{ axisLabel: { padding: 40 } }}
          tickLabelComponent={
            <VictoryPortal>
              <VictoryLabel
                text={y => {
                  return y + "%";
                }}
              />
            </VictoryPortal>
          }
        />
        <VictoryAxis
          tickCount={data.length}
          style={{ axisLabel: { padding: 30 } }}
          tickLabelComponent={
            <VictoryPortal>
              <VictoryLabel angle={25} />
            </VictoryPortal>
          }
        />
        <VictoryLine
          style={{
            data: { stroke: "#707070" },
            parent: { border: "1px solid #ccc" },
          }}
          data={data}
        />
        <VictoryScatter
          style={{ data: { fill: "#505050" } }}
          size={3}
          data={data}
          labels={d => d.y.toFixed(1) + "%"}
          labelComponent={<VictoryTooltip />}
        />
      </VictoryChart>
    );
  }
}

export default MonthProfitChart;



// WEBPACK FOOTER //
// ./src/charts/MonthProfitChart.js